module.exports = __webpack_public_path__ + "assets/img/logo.804417dc.png";